// Angular
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
// Models
import { PTableCompGridFormattedDataValues } from '../model/p-table-comp-grid-data.model';
import { RuleModel } from '../../../rules/model/rule.model';
// Services
import { BroadcastService } from '@cv-invision/core';
import { CompGridService } from '../service/comp-grid.service';
// RXJS
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
// State
import { RulesState } from '../../../rules/state/rules.state';
// NGXS
import { Store } from '@ngxs/store';
// other
import { UI_FIELD_SELECTED_EVENT } from '../../../rules/rules.component';

@Component({
  selector: 'cv-custom-p-table-comp-grid-cell',
  templateUrl: './custom-p-table-comp-grid-cell.component.html',
  styleUrls: ['./custom-p-table-comp-grid-cell.component.scss']
})
export class CustomPTableCompGridCellComponent implements OnInit, OnDestroy {
  @Input() value: PTableCompGridFormattedDataValues;
  @Output() updateScroll: EventEmitter<any> = new EventEmitter();

  rules$: Observable<any> = this.store.select(RulesState.getOrderRules);

  private subscription: Subscription;
  private atComponentDestroy = new Subject();
  public rules: any;
  public highlightType = '';
  public paths: string[] = [];
  constructor(
    private store: Store,
    private broadcastService: BroadcastService,
    private compGridService: CompGridService,
    public elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    if (this.value.path !== undefined) {
      this.paths = this.value.path
    }

    this.subscription = this.compGridService.getRuleSelected().subscribe(data => {
      const isExist = data.targets.includes(this.paths[0]);
      const isLastItem = data.targets[data.targets.length - 1] === this.paths[0] ? true : false;
      isExist ? this.highlightType = data.type : this.highlightType = '';

      if (isExist && isLastItem) {
        // update p-table's scroll to default (0,0)
        this.updateScroll.emit();
        // scroll to the selected rule cell. 
        this.elementRef.nativeElement.scrollIntoView({ block: 'end', inline: 'nearest' });
      }
    });

    this.rules$.pipe(takeUntil(this.atComponentDestroy)).subscribe((orderRules: any) => {
      this.rules = orderRules;
    });

  }

  /**
* Select field
*/
  onFieldSelected(): void {
    if (this.value.path !== undefined && this.value.path.length > 0) {
      const rules = this.getFieldRules(this.value.path[0]);

      if (rules.length) {
        this.broadcastService.broadcast({
          name: UI_FIELD_SELECTED_EVENT,
          event: {
            rule: rules[0]
          }
        });
      }
    }
  }

  /**
 * Return the rules asigned to the field
 * @param fieldPath 
 */
  getFieldRules(fieldPath: string): Array<RuleModel> {
    const field = fieldPath.replace(/[^a-zA-Z ]/g, '').toLowerCase();
    const rules: Array<RuleModel> = this.rules.violation.filter(rule => {
      let isAvailable = false;
      if (rule.targets.length) {
        const targets = rule.targets.join().replace(/[^a-zA-Z ]/g, '').toLowerCase();
        isAvailable = targets.indexOf(field) !== -1;
      }
      return isAvailable;
    });

    return rules;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
